/* eslint-disable @typescript-eslint/no-explicit-any */
import flowActionsTemplate from '@/app/editor/sidebar/actions/actions.html';
import type { ActionData } from './type';
import type { FlowActionDataEditor, ActionDataEditor } from './type';
import { atomIDToBkID } from '@/app/utils/helpers';
import store from '@/app/store/store';
import FlowActionItem from './class/FlowActionItem';
import DropdownGroupControl from '../controlsv2/dropdown-group';
import { app } from '@/store';
import { base } from '@/app/editor/sidebar/constant';

/**
 * Flow Actions class
 */
export default class FlowActionsPanel {
  $html: JQuery;
  $atom: JQuery;
  atomID: string;
  atomLabel: string;
  $gfLeftSideBar: JQuery;
  $actionTab: JQuery;
  $actionPanel: JQuery;
  $actionBody: JQuery;
  $actionsList: JQuery;
  $gfFrame: JQuery;
  $emptyBox: JQuery;
  dropdownGroupControl: DropdownGroupControl;
  // Should have a config/setting/data in each Atom instead of check by label
  flowActionItem: FlowActionItem[] = [];
  selectedAnimation: Animation;

  /**
   * Constructor
   * @param $atom ..
   */
  constructor($atom: JQuery) {
    this.$atom = $atom;
    this.atomID = this.$atom.attr('id') || '';
    this.atomLabel = this.$atom.attr('data-label') || '';
    this.$gfLeftSideBar = jQuery('#gfLeftSideBar');
    this.$actionTab = jQuery('.simple-tabs');
    this.$gfFrame = jQuery('#gfFrame');

    //off click outside
    jQuery(window).off('click.outside');

    //open settings
    this.openSettings();

    return this;
  }

  /**
   * openSettings
   * @returns void
   */
  openSettings(): void {
    this.renderTemplate();
    return;
  }

  /**
   * renderTemplate
   * @returns void
   */
  renderTemplate(): void {
    const _this = this;
    const html = flowActionsTemplate(this.atomLabel);
    this.$html = jQuery(html);

    const $oldPanel = this.$gfLeftSideBar.find('#md-settings .simple-tabs .actions-panel');
    if ($oldPanel.length) {
      $oldPanel.remove();
    }
    $(this.$html).insertAfter(this.$gfLeftSideBar.find('#md-settings .simple-tabs .md-body').last());

    this.$emptyBox = this.$html.find('.actions-empty');

    // Need async function to init data
    this.$actionPanel = this.$html;
    this.$actionBody = this.$html.find('.actions-body');
    this.$actionsList = this.$html.find('.actions-list');

    (this.$actionBody.addClass('optiscroll') as any).optiscroll();

    const $selectEvents = this.$html.find('.list-event select');

    const opts = {
      enableDescription: true,
      /**
       * onChange
       * @param data .
       */
      onChange: async (data: any) => {
        const flowActionItem = new FlowActionItem(_this.$actionsList, _this.$atom, undefined);
        flowActionItem.setEvents([{ key: data.value }]);
        flowActionItem.refreshEvents();
        flowActionItem.$html.find('.flow-head').trigger('click');

        //enable when product
        // Object(flowActionItem.targetItems)["0"].enableSelectTargetMode();

        //suggest select target
        if (!_this.flowActionItem.length) {
          Object(flowActionItem.targetItems)['0'].suggestSelectTarget();
        }

        _this.flowActionItem.push(flowActionItem);
        store.setValue('update-action', 1);
      },
      /**
       * onOpened
       */
      onOpened: () => {
        // _this.$actionPanel.find(".actions-overlay").fadeIn();
        _this.$actionPanel.addClass('overlay');
      },
      /**
       * onClosed
       */
      onClosed: () => {
        _this.$actionPanel.removeClass('overlay');
        // _this.$actionPanel.find(".actions-overlay").fadeOut();
      },
    };

    //add event
    $selectEvents.each(function () {
      _this.dropdownGroupControl = new DropdownGroupControl(jQuery(this), opts);
    });

    this.applyEvents();

    const actionData = this.getActionItemsFromContentBk();
    for (let i = 0; i < actionData.length; i++) {
      this.flowActionItem.push(new FlowActionItem(this.$actionsList, this.$atom, actionData[i]));
    }

    this.showEmptyBox();

    store.unset('update-action');
    store.onChange('update-action', function () {
      _this.updateActionItemsToContentBk();

      //check empty
      _this.showEmptyBox();
    });

    return;
  }

  /**
   * showEmptyBox
   */
  showEmptyBox(): void {
    if (this.flowActionItem.length) {
      this.$emptyBox.hide(0);
    } else {
      this.$emptyBox.show(0);
    }
  }

  /**
   * getActionItemsFromContentBk
   * @returns ..
   */
  getActionItemsFromContentBk(): FlowActionDataEditor[] {
    const atomID = this.$atom.attr('id') || '';
    const contentBkID = atomIDToBkID(atomID);
    const data = (app as any).$store.getters['editor/GET_ANIMATION_ACTION_SETTING_BY_KEY'](
      base._actions + '_' + contentBkID,
    );

    if (data) {
      try {
        return JSON.parse(data);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn(e);
        return [];
      }
    }

    return [];
  }

  /**
   * update data
   */
  updateActionItemsToContentBk(): void {
    const atomID = this.$atom.attr('id') || '';
    const contentBkID = atomIDToBkID(atomID);

    const dataActions = [];
    const tempFlowActionItem: FlowActionItem[] = [];
    for (let i = 0; i < this.flowActionItem.length; i++) {
      const flowAction = this.flowActionItem[i].export();
      if (flowAction) {
        tempFlowActionItem.push(this.flowActionItem[i]);
        dataActions.push(flowAction);
      }
    }

    this.flowActionItem = tempFlowActionItem;
    (app as any).$store.commit('editor/SET_ANIMATION_DATA_SETTINGS', {
      id: base._actions + '_' + contentBkID,
      type: 'action',
      value: JSON.stringify(dataActions),
    });
  }

  /**
   * convertEditorToAction
   * @param actionDataEditor ..
   * @returns ..
   */
  convertEditorToAction(actionDataEditor: ActionDataEditor): ActionData {
    const action = actionDataEditor;

    delete Object(action).name;
    delete Object(action).description;

    return action;
  }

  /**
   * Thêm sự kiện cho template
   */
  applyEvents(): void {
    const _this = this;
    this.$actionTab
      .find('.tab-action-icon')
      .off('click')
      .on('click', function () {
        //event add actions group
        _this.dropdownGroupControl.toggle();
      });
  }
}
